import { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { CspPath } from '../../../CspPath';
import { useNavigationContext } from '../../navigation/context/useNavigationContextState';

export const StudyArchivingDefaultRoute: FC = () => {
  const navContext = useNavigationContext();
  const selectedSubTab = navContext.getSelectedSubPath(CspPath.STUDY_OVERVIEW_ARCHIVING);

  return <Navigate to={selectedSubTab ?? CspPath.STUDY_OVERVIEW_ARCHIVING_FILES} replace />;
};
